import { gsap } from "gsap";

function buildDigits(valueEl, value) {
    const digitsWrapper = valueEl.querySelector(".counter__digits");
    if (!digitsWrapper) return [];

    digitsWrapper.innerHTML = "";
    const chars = String(value).split("");

    const columns = chars.map((char) => {
        const col = document.createElement("span");
        col.className = "counter__digit-column";

        const track = document.createElement("span");
        track.className = "counter__digit-track";

        if (!/\d/.test(char)) {
            const digitEl = document.createElement("span");
            digitEl.className = "counter__digit";
            digitEl.textContent = char;
            track.appendChild(digitEl);
            col.appendChild(track);
            digitsWrapper.appendChild(col);
            col.dataset.targetDigit = char;
            return col;
        }

        for (let loop = 0; loop < 3; loop += 1) {
            for (let i = 0; i <= 9; i += 1) {
                const digitEl = document.createElement("span");
                digitEl.className = "counter__digit";
                digitEl.textContent = String(i);
                track.appendChild(digitEl);
            }
        }

        col.appendChild(track);
        digitsWrapper.appendChild(col);
        col.dataset.targetDigit = char;
        return col;
    });

    valueEl.classList.add("counter__value--ready");
    return columns;
}

function animateDigits(valueEl, value) {
    if (valueEl.classList.contains("is-animated")) return;
    if (Number.isNaN(value)) return;

    const columns = buildDigits(valueEl, value);
    if (!columns.length) return;

    const valueStyles = window.getComputedStyle(valueEl);
    const baseHeight = parseFloat(valueStyles.lineHeight) || parseFloat(valueStyles.fontSize) || 0;

    columns.forEach((col, index) => {
        const targetChar = col.dataset.targetDigit || "0";
        const track = col.querySelector(".counter__digit-track");
        if (!track) return;

        if (baseHeight) {
            col.style.height = `${baseHeight}px`;
        }

        if (!/\d/.test(targetChar)) {
            gsap.set(track, { y: 0 });
            return;
        }

        let digitHeight = col.getBoundingClientRect().height || col.offsetHeight || baseHeight;
        if (!digitHeight) {
            const lineHeight = parseFloat(window.getComputedStyle(col).lineHeight);
            const fontSize = parseFloat(window.getComputedStyle(valueEl).fontSize);
            digitHeight = lineHeight || fontSize || 0;
        }
        if (!digitHeight) return;

        const startDigit = Math.floor(Math.random() * 10);
        const targetDigit = parseInt(targetChar, 10);
        const targetIndex = targetDigit + 20; // 2 full loops + target

        gsap.set(track, { y: -startDigit * digitHeight });
        gsap.to(track, {
            y: -targetIndex * digitHeight,
            duration: 1.6 + index * 0.1,
            ease: "power2.out"
        });
    });

    valueEl.classList.add("is-animated");
}

function initCounters(root = document) {
    const blocks = root.querySelectorAll(".block-counter");
    if (!blocks.length) return;

    const triggerBlock = (block) => {
        const counters = block.querySelectorAll(".counter__value[data-counter]");
        counters.forEach((counter) => {
            const rawValue = counter.getAttribute("data-counter");
            if (rawValue === null || rawValue === "") return;
            const value = parseInt(rawValue, 10);
            if (Number.isNaN(value)) return;
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    animateDigits(counter, value);
                });
            });
        });
    };

    const isInView = (el) => {
        const rect = el.getBoundingClientRect();
        const viewHeight = window.innerHeight || document.documentElement.clientHeight;
        return rect.top < viewHeight * 0.9 && rect.bottom > viewHeight * 0.1;
    };

    if (!("IntersectionObserver" in window)) {
        blocks.forEach((block) => triggerBlock(block));
        return;
    }

    const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach((entry) => {
            if (!entry.isIntersecting) return;

            const block = entry.target;
            triggerBlock(block);

            obs.unobserve(block);
        });
    }, {
        threshold: 0.2,
        rootMargin: "0px 0px -5% 0px"
    });

    blocks.forEach((block) => {
        if (block.__counterInit) return;
        block.__counterInit = true;
        if (isInView(block)) {
            triggerBlock(block);
            return;
        }
        observer.observe(block);
    });
}

export { initCounters };

if (typeof document !== "undefined") {
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", () => initCounters());
    } else {
        initCounters();
    }
}
